// RTableGroupView: a consistent snapshot of all member tables at one group
// position. The schema is resolved eagerly when the view is built (mirrors
// RSchemaViewImpl holding a resolved SchemaState), so getSchemaView() is
// synchronous; member table views are anchored at THIS view's (at, from) —
// the cohesion guarantee.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class RTableGroupViewImpl {
    constructor(target, at, from, schemaVersion, schemaView) {
        this.target = target;
        this.at = at;
        this.from = from;
        this.schemaVersion = schemaVersion;
        this.schemaView = schemaView;
    }
    getObject() {
        return this.target;
    }
    getVersion() {
        return this.at;
    }
    getFromVersion() {
        return this.from;
    }
    getReferences() {
        return __awaiter(this, void 0, void 0, function* () {
            return [this.target.getSchemaRef(), ...Object.values(this.target.getBindings())];
        });
    }
    resolveRefVersion(refId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (refId === this.target.getSchemaRef()) {
                return this.schemaVersion;
            }
            if (Object.values(this.target.getBindings()).includes(refId)) {
                // The observed foreign version of a bound group at this view's
                // position — the same resolveRefVersionAtPosition source that
                // cross-group FK / exists resolution uses on the group DAG.
                return this.target.resolveObservedForeignVersion(refId, this.at, this.from);
            }
            throw new Error("Unknown reference: " + refId);
        });
    }
    // The effective schema at this position
    getSchemaVersion() {
        return this.schemaVersion;
    }
    getSchemaView() {
        return this.schemaView;
    }
    getTableNames() {
        return this.schemaView.getTableNames();
    }
    // Member table view pinned at this view's position: all tables observed
    // at the same snapshot.
    getTableView(name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.schemaView.hasTable(name)) {
                throw new Error(`Table '${name}' does not exist in the effective schema at this position`);
            }
            const table = this.target.makeTable(name);
            return table.getView(this.at, this.from);
        });
    }
}
